import { useMutation, useQuery } from "react-query";
import {
  enqueueDownload,
  enqueueStage4Backfill,
  getCaptableRun,
  getDownloadJob,
  getStage4BackfillStatus,
  listS3Files,
  publishPas3,
  rerunMgt7,
  rerunPas3,
  uploadCaptableExcel,
  uploadFinancialToCaptable,
  uploadStage4Excel,
  type RerunMgt7Payload,
  type RerunPas3Payload,
} from "../api/dataPipeline";

export function useListS3Files() {
  return useQuery({
    queryFn: listS3Files,
    queryKey: "listS3Files",
    retry: false,
  });
}

export function useEnqueueDownload() {
  return useMutation({
    mutationKey: "enqueueDownload",
    mutationFn: enqueueDownload,
  });
}

export function useDownloadJob(jobId: string | null) {
  return useQuery({
    queryKey: ["downloadJob", jobId],
    queryFn: () => getDownloadJob(jobId as string),
    enabled: !!jobId,
    retry: false,
    refetchInterval: (data) => {
      if (!data) return 3000;
      if (data.state === "completed" || data.state === "failed") return false;
      return 3000;
    },
  });
}

export function usePublishPas3() {
  return useMutation({
    mutationKey: "publishPas3",
    mutationFn: publishPas3,
  });
}

export function useUploadCaptableExcel() {
  return useMutation({
    mutationKey: "uploadCaptableExcel",
    mutationFn: uploadCaptableExcel,
  });
}

export function useRerunMgt7() {
  return useMutation({
    mutationKey: "rerunMgt7",
    mutationFn: ({
      sourceRunId,
      payload,
    }: {
      sourceRunId: string;
      payload?: RerunMgt7Payload;
    }) => rerunMgt7(sourceRunId, payload),
  });
}

export function useRerunPas3() {
  return useMutation({
    mutationKey: "rerunPas3",
    mutationFn: ({
      sourceRunId,
      payload,
    }: {
      sourceRunId: string;
      payload?: RerunPas3Payload;
    }) => rerunPas3(sourceRunId, payload),
  });
}

export function useUploadStage4Excel() {
  return useMutation({
    mutationKey: "uploadStage4Excel",
    mutationFn: uploadStage4Excel,
  });
}

export function useUploadFinancialToCaptable() {
  return useMutation({
    mutationKey: "uploadFinancialToCaptable",
    mutationFn: uploadFinancialToCaptable,
  });
}

export function useCaptableRun(runId: string | null) {
  return useQuery({
    queryKey: ["captableRun", runId],
    queryFn: () => getCaptableRun(runId as string),
    enabled: !!runId,
    retry: false,
    refetchInterval: (data) => {
      if (!data) return 5000;
      if (data.status === "COMPLETED" || data.status === "FAILED") return false;
      return 5000;
    },
  });
}

export function useEnqueueStage4Backfill() {
  return useMutation({
    mutationKey: "enqueueStage4Backfill",
    mutationFn: enqueueStage4Backfill,
  });
}

export function useStage4BackfillStatus(jobId: string | null) {
  return useQuery({
    queryKey: ["stage4BackfillStatus", jobId],
    queryFn: () => getStage4BackfillStatus(jobId as string),
    enabled: !!jobId,
    retry: false,
    refetchInterval: (data) => {
      if (!data) return 2000;
      return data.status === "COMPLETED" ? false : 2000;
    },
  });
}
